const topNavigationSticky = () => {
  const navBar = document.querySelector(".top-navigation__container");

  // Pin the masthead/navbar when scrolling down
  if (navBar) {
    const masthead = document.querySelector("#masthead");
    
    // Check if mobile (tablet max breakpoint is typically 1024px)
    const isMobile = window.innerWidth <= 1024;

    // On mobile, disable ScrollTrigger pinning entirely to avoid Android Edge issues
    // CSS position: sticky will handle it instead
    if (!isMobile && masthead) {
      // Desktop pinning only (original behavior)
      ScrollTrigger.create({
        trigger: masthead,
        start: "top top",
        end: "max",
        pinSpacing: false,
        pin: true,
      });
    }
    // Mobile will rely on CSS position: sticky instead
  }
};

// Initialize when DOM is ready
if (document.readyState !== "loading") {
  topNavigationSticky();
} else {
  document.addEventListener("DOMContentLoaded", topNavigationSticky);
}
